import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const workspacesApi = createApi({
  reducerPath: 'workspacesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['WorkspaceDashboard'],
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getWorkspaceDashboard: builder.query({
      query: ({ workspaceId }) => ({
        url: `/workspaces/${workspaceId}/dashboard`,
        method: 'GET',
      }),
      providesTags: (result, error, { workspaceId }) => [
        { type: 'WorkspaceDashboard', id: workspaceId },
      ],
    }),
  }),
});

export const { useGetWorkspaceDashboardQuery } = workspacesApi;
